'use client';

import { useEffect } from 'react';

import { watchAndHideIntercomLauncher } from '~/lib/intercom/intercom';

/**
 * Keeps Intercom's default Fin bubble hidden. Segment loads the Messenger;
 * Support (`#assignar-pay-support-button`) is the only launcher (PAY-2699).
 */
export function IntercomLauncherController() {
  useEffect(() => watchAndHideIntercomLauncher(), []);

  return null;
}
